import { useGetFeatureFlagsQuery } from '../api/featuresApi';
import type { FeatureFlags } from '../api/featuresApi';

// Safe defaults while loading — all v3 pages off
const DEFAULTS: FeatureFlags = {
    HomeV3:              false,
    ProfessionalsV3:     false,
    OrganizationsV3:     false,
    ExUsProfessionalsV3: false,
    TargetingV3:         false,
    ExhibitsDisplaysV3:  false,
    AdminV3:             false,
    ExhibitsDisplaysBroadAccess: false,
    OrganizationsDermTeamsAccess: false,
    AffiliationsEditDermTeamsAccess: false,
};

/**
 * Returns the current feature flag state.
 * Returns safe defaults (all false) while the query is loading so callers
 * never need to check isLoading — FeatureGate handles that centrally.
 */
export function useFeatureFlags(): FeatureFlags {
    const { data } = useGetFeatureFlagsQuery();
    return data ?? DEFAULTS;
}
